import { render, staticRenderFns } from "./MultiDocumentTableAddDZ.vue?vue&type=template&id=61a3f1f0&scoped=true"
import script from "./MultiDocumentTableAddDZ.vue?vue&type=script&lang=js"
export * from "./MultiDocumentTableAddDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3f1f0",
  null
  
)

export default component.exports